(function () {
  'use strict';

  angular.module('app').component('packageList', packageList());

  function packageList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: PackagelistComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/packages/package-list/package-list.component.html',
    };
  }

  PackagelistComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'PackageService',

    // Angular downgraded service
    'locationService',
  ];

  function PackagelistComponent(
    config,
    UtilService,
    AbilityService,
    PackageService,

    // Angular downgraded service
    locationService
  ) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_package_accountadmin'),
      canUpdate: AbilityService.can('update_package_accountadmin'),
      canDestroy: AbilityService.can('destroy_package_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.filterCriteria = PackageService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;

    vm.searchLocations = (search, option) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      locationService.getLocations(params).subscribe((response) => {
        let locations = response;

        if (option === 'departure') {
          vm.departureLocations = locations;
        } else {
          vm.arrivalLocations = locations;
        }
      });
    };

    vm.clearLocations = (option) => {
      if (option === 'departure') {
        vm.departureLocations = [];
      } else {
        vm.arrivalLocations = [];
      }

      vm.UtilService.filterResult();
    };

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      PackageService.getPackages(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.departureLocations = [];
      vm.arrivalLocations = [];

      vm.filterCriteria = PackageService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }
      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      PackageService.deletePackage(item, fetchResult);
    }

    function changeItemStatus(item) {
      PackageService.changePackageStatus(item);
    }
  }
})();
